import React from 'react';
import { Layout } from '../components/common';

const ReportsDemo = () => {
  return (
    <Layout activeNav="reports" onNavChange={() => {}}>
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-gray-800 mb-2">Reports</h1>
        <p className="text-gray-600">View warehouse reports and analytics.</p>
      </div>

      <div className="bg-white rounded-lg shadow p-8 text-center">
        <p className="text-gray-600 text-lg">Reports Content Coming Soon</p>
      </div>
    </Layout>
  );
};

export default ReportsDemo;
